import React from 'react';

import PropTypes from 'prop-types';

import { HeaderPanel } from 'apps/auth/components/common/Layout/HeaderPanel/HeaderPanel';
import { Row } from 'apps/auth/components/common/Layout/Row';
import InputAutoDetect from 'apps/auth/components/form/InputAutoDetect';
import { useFields, usePageMessages } from 'apps/auth/hooks/selectors';
import { checkFromField } from 'apps/auth/services/GTRequestMultiScreenService';

import { getSortFields } from '../form-multi/utils';

const PayFromFields = (props) => {
    const { payRequestFieldsFromLeft } = usePageMessages();
    const fields = useFields(props.formName);

    const getVisibleFields = () => {
        let visibleFields = [];
        getSortFields(fields).forEach((field) => {
            if (checkFromField(field)) {
                visibleFields.push(field);
            }
        });
        return visibleFields;
    };

    if (getVisibleFields().length > 0) {
        return (
            <>
                <HeaderPanel title={payRequestFieldsFromLeft} />
                <Row indent="adaptive-32-48">
                    <>
                        {getVisibleFields().map((field) => {
                            return (
                                <Row indent="adaptive-24-32" key={`${field.id}${field.name}`}>
                                    <InputAutoDetect field={field} formName={props.formName} />
                                </Row>
                            );
                        })}
                    </>
                </Row>
            </>
        );
    } else {
        return false;
    }
};
PayFromFields.propTypes = {
    formName: PropTypes.string.isRequired,
};

export default PayFromFields;
